function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,30.196078%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 3.796875 24.257812 L 1.582031 0 L 25.367188 0 L 23.203125 24.257812 L 13.5 27 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(16.078431%,39.607843%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 13.5 1.953125 L 13.5 24.890625 L 21.359375 22.726562 L 23.203125 1.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 6.011719 4.957031 L 13.5 4.957031 L 13.5 7.910156 L 6.273438 7.910156 M 6.539062 10.96875 L 13.5 10.96875 L 13.5 13.976562 L 6.804688 13.976562 M 6.960938 15.453125 L 9.914062 15.453125 L 10.125 17.824219 L 13.5 18.71875 L 13.5 21.832031 L 7.328125 20.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.5 10.96875 L 13.5 13.976562 L 17.140625 13.976562 L 16.769531 17.824219 L 13.5 18.71875 L 13.5 21.832031 L 19.5625 20.144531 L 20.9375 4.957031 L 13.5 4.957031 L 13.5 7.910156 L 17.71875 7.910156 L 17.429688 10.96875 Z M 13.5 10.96875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.c91201db7c359bf8fbcc19755b21bf37.svg";
export { ForwardRef as ReactComponent };